// Import the functions you need from the SDKs you need
import { initializeApp, getApps } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getFirestore, initializeFirestore, collection, doc, getDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// @ts-ignore
import emailjs from '@emailjs/browser';
import { query, where, getDocs, limit } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAxQS5lltAiuXOCbqv1O0m06Cle9n3J8vo",
  authDomain: "lotus-l1.firebaseapp.com",
  projectId: "lotus-l1",
  storageBucket: "lotus-l1.firebasestorage.app",
  messagingSenderId: "962581548833",
  appId: "1:962581548833:web:464290da0e70ba598fb860", // Updated from user snippet
  measurementId: "G-13NLEV4VVJ"
};

// Safe initialization
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;
const auth = getAuth(app);

const db = (() => {
  if (typeof window !== 'undefined') {
    try {
      return initializeFirestore(app, {
        experimentalForceLongPolling: true,
      });
    } catch (e) {
      return getFirestore(app);
    }
  }
  return getFirestore(app);
})();

const storage = getStorage(app);

// Enable persistence
if (typeof window !== 'undefined') {
  setPersistence(auth, browserLocalPersistence);
}

// Initialize EmailJS
emailjs.init("bf8tIWB-KuPJo9_qz");

/**
 * Helper to check if a user exists in the 'users' collection (lotus project requirement)
 */
export const checkUserExists = async (email: string, uid?: string) => {
  try {
    // 1. Try UID lookup first as it's more direct and follows standard security rules
    if (uid) {
      const userDoc = await getDoc(doc(db, "users", uid));
      if (userDoc.exists()) return true;
    }

    // 2. Fallback to email query if UID lookup fails or is not provided
    // (Note: This might still trigger permission errors if rules are strict)
    const usersRef = collection(db, "users");
    const q = query(usersRef, where("email", "==", email), limit(1));
    const querySnapshot = await getDocs(q);
    return !querySnapshot.empty;
  } catch (error: any) {
    console.error("Firestore Permission Error logic check: ", error);
    // If we can't query the collection due to permissions, and UID check failed,
    // we assume the user doesn't have a record in the database yet.
    return false;
  }
};

export { app, analytics, auth, db, storage, emailjs };
